// Web mock for react-native-fs
const RNFS = {
  DocumentDirectoryPath: '/documents',
  CachesDirectoryPath: '/caches',
  ExternalDirectoryPath: '/external',
  ExternalStorageDirectoryPath: '/external-storage',
  TemporaryDirectoryPath: '/temp',
  LibraryDirectoryPath: '/library',
  MainBundlePath: '/main-bundle',
  DownloadDirectoryPath: '/downloads',

  readFile: async (path: string, encoding?: string): Promise<string> => {
    console.warn('[RNFS Web] readFile is not fully supported on web:', path);
    return '';
  },

  writeFile: async (path: string, content: string, encoding?: string): Promise<void> => {
    console.warn('[RNFS Web] writeFile is not fully supported on web:', path);
    try {
      localStorage.setItem(`rnfs_${path}`, content);
    } catch {
      // Storage might be full
    }
  },

  exists: async (path: string): Promise<boolean> => {
    return localStorage.getItem(`rnfs_${path}`) !== null;
  },

  stat: async (path: string) => {
    return {
      name: path.split('/').pop() || '',
      path,
      size: 0,
      mode: 0,
      ctime: new Date(),
      mtime: new Date(),
      isFile: () => true,
      isDirectory: () => false,
    };
  },

  unlink: async (path: string): Promise<void> => {
    localStorage.removeItem(`rnfs_${path}`);
  },

  mkdir: async (_path: string): Promise<void> => {
    // No-op on web
  },

  downloadFile: (options: any) => {
    const { fromUrl, toFile, begin, progress } = options;
    const jobId = Math.random();

    const promise = fetch(fromUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        localStorage.setItem(`rnfs_${toFile}`, url);
        return {
          jobId,
          statusCode: 200,
          bytesWritten: blob.size,
        };
      });

    return { jobId, promise };
  },

  readDir: async (_path: string) => {
    return [];
  },

  copyFile: async (from: string, to: string): Promise<void> => {
    const content = localStorage.getItem(`rnfs_${from}`);
    if (content) {
      localStorage.setItem(`rnfs_${to}`, content);
    }
  },

  moveFile: async (from: string, to: string): Promise<void> => {
    const content = localStorage.getItem(`rnfs_${from}`);
    if (content) {
      localStorage.setItem(`rnfs_${to}`, content);
      localStorage.removeItem(`rnfs_${from}`);
    }
  },

  readFileAssets: async (_path: string, _encoding?: string): Promise<string> => {
    return '';
  },

  hash: async (_path: string, _algorithm: string): Promise<string> => {
    return '';
  },

  touch: async (_path: string, _mtime?: Date, _ctime?: Date): Promise<void> => {
    // No-op
  },

  stopDownload: (_jobId: number): void => {
    // No-op
  },
};

export default RNFS;
